import { render, staticRenderFns } from "./persentase_tren_emotion.vue?vue&type=template&id=1a8c81c6"
import script from "./persentase_tren_emotion.vue?vue&type=script&lang=js"
export * from "./persentase_tren_emotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports